<template>
	<v-select-dropdown :items="items" :selectedItems="selectedItems" @onItemSelected="onClick">
		<template v-slot:header="{ active }">
			<span v-if="active">{{ active.faqCategory }}</span>
		</template>
		<template v-slot:item="{ item }">{{ item.faqCategory }}</template>
	</v-select-dropdown>
</template>

<script>
import VIcon from '../icon/VIcon.vue';
import VSelectDropdown from '../select-dropdown/VSelectDropdown.vue';

export default {
	name: "VFaqMenu",
	components: {
		VIcon,
		VSelectDropdown
	},
	data() {
		return { selectedItems: [] }
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		onClick: function (item) {
			window.location.href = `?id=${item.id}`;
		}
	},
	mounted: function () {
		this.selectedItems = this.items.filter(e => e.active);
	}
};
</script>
